import { Record } from 'immutable';
const CrmObjectTypeRecord = Record({
  name: null,
  objectTypeId: null,
  pluralForm: null,
  singularForm: null,
  primaryDisplayLabelPropertyName: null,
  disabled: undefined
});
export default CrmObjectTypeRecord;